<div class="user-panel">
  @if (menuMode === 'context') {
    <dx-drop-down-button
      stylingMode="text"
      dropDownContentTemplate="dropDownTemplate"
      [icon]="user?.avatarSource || 'user'"
      [showArrowIcon]="false"
    [elementAttr]="{
      class: 'user-button'
    }"
    [dropDownOptions]="{
      width: '150'
    }"
      (onContentReady)="handleDropDownButtonContentReady($event)"
      >
      <div *dxTemplate="let data of 'dropDownTemplate'">
        <user-menu-section
          [menuItems]="menuItems"
          [showAvatar]="false"
          [user]="user"
        ></user-menu-section>
      </div>
    </dx-drop-down-button>
  }
  @if (menuMode === 'list') {
    <div>
      <user-menu-section
        [menuItems]="menuItems"
        [showAvatar]="true"
        [user]="user"
      ></user-menu-section>
    </div>
  }
</div>
